<template>
  <div class="container-fluid mb-2">
    <d-row>
      <d-col class="col-table" v-if="!isCustomer">
        <table class="table mb-0 table-striped">
          <thead>
            <tr>
              <th scope="col" class="border-0 px-0 pb-0">Todas as regiões</th>
            </tr>
            <div class="d-flex py-2">
              <div class="input-group mr-2">
                <select-state
                  :model.sync="pagination.state"
                  :onChange="onChangeStates"
                />
              </div>
              <form
                class="main-sidebar__search w-100 p-0 d-flex border rounded"
              >
                <input-search
                  :model.sync="pagination.search"
                  id="input_detached_search"
                />
              </form>
            </div>
          </thead>
          <tbody class="border-left border-right row-table">
            <tr v-for="(row, index) in detachedRegions.list" :key="index">
              <td
                :class="['td-4', isSelected(row) ? 'selected' : '']"
                @click="selectRow(row, 'attached')"
              >
                <span>{{ row.city }} - {{ row.state }}</span>
              </td>
            </tr>
            <tr v-if="detachedRegions.total_items === 0">
              <td class="no-content">
                {{
                  pagination.search
                    ? 'Nenhuma região encontrada para o termo pesquisado.'
                    : 'Não ha regiões cadastradas'
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          :total-items="detachedRegions.total_items"
          :pagination.sync="pagination"
          :eventName="'update:pagination_detached_regions'"
        ></pagination>
      </d-col>
      <d-col
        cols="1"
        class="d-flex align-items-center justify-content-center"
        v-if="!isCustomer"
      >
        <d-button class="btn-outline-info btn-sm" @click.prevent="sync">
          <i class="material-icons">sync_alt</i>
        </d-button>
      </d-col>
      <d-col class="col-table">
        <table class="table mb-0 table-striped">
          <thead>
            <tr>
              <th scope="col" class="border-0 px-0 pb-0">
                Regiões Selecionadas
              </th>
            </tr>
            <div class="d-flex py-2">
              <form
                class="main-sidebar__search w-100 p-0 d-flex border rounded"
              >
                <input-search
                  :model.sync="paginationAttached.search"
                  id="input_attached_search"
                />
              </form>
            </div>
          </thead>
          <tbody class="border-left border-right row-table">
            <tr
              v-for="(row, index) in attachedRegions.list.slice(0, 10)"
              :key="index"
            >
              <td
                :class="['td-4', isSelected(row) ? 'selected' : '']"
                @click="selectRow(row, 'detached')"
              >
                <span>{{ row.city }} - {{ row.state }}</span>
              </td>
            </tr>
            <tr v-if="attachedRegions.total_items === 0">
              <td class="no-content">
                {{
                  paginationAttached.search
                    ? 'Nenhuma região encontrada para o termo pesquisado.'
                    : 'Não tem nenhuma região atribuida.'
                }}
              </td>
            </tr>
          </tbody>
          <pagination
            :total-items="attachedRegions.total_items"
            :pagination.sync="paginationAttached"
            :eventName="'update:pagination_attached_regions'"
          ></pagination>
        </table>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_common/shared/Pagination.vue';
import SelectState from '_shared/SelectState.vue';
import InputSearch from '_shared/InputSearch.vue';
import { compareObjects } from '_utils';
import { ATTACHED, DETACHED } from './DistributorModel';

export default {
  name: 'cities',
  components: {
    SelectState,
    Pagination,
    InputSearch,
  },
  data() {
    return {
      type: ATTACHED,
      timer: null,
      selected: [],
      distributorId: null,
      pagination: {
        group: DETACHED,
        search: '',
        state: null,
        skip: 0,
        take: 10,
        page: 1,
      },
      paginationAttached: {
        group: ATTACHED,
        search: '',
        state: null,
        skip: 0,
        take: 10,
        page: 1,
      },
    };
  },
  computed: {
    detachedRegions() {
      const { detachedRegions } = this.$store.state.distributor;
      if (detachedRegions) {
        return detachedRegions;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    allAttachedRegionData() {
      const { allAttachedRegions } = this.$store.state.distributor;
      if (allAttachedRegions) {
        return allAttachedRegions.list;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
    attachedRegions: {
      get() {
        const { attachedRegions } = this.$store.state.distributor;
        if (attachedRegions) {
          return attachedRegions;
        }
        return {
          list: [],
          total_items: 0,
        };
      },
      set(attachedRegions) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.syncRegions({
            attachedRegions,
            id: this.distributorId,
          })
            .then(this.saveSuccess)
            .catch(this.saveError);
        }, 800);
      },
    },
  },
  methods: {
    ...mapActions(['activeAlert', 'syncRegions', 'getDistributorRegions']),
    attach() {
      this.syncRegions({
        attachedRegions: this.prepareAttached(),
        id: this.distributorId,
      })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    detach() {
      this.syncRegions({
        attachedRegions: this.prepareDetached(),
        id: this.distributorId,
      })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    getRegions() {
      this.getRegionList(this.pagination);
      this.getRegionList({ ...this.paginationAttached, take: 0 });
    },
    getRegionList(paginate) {
      this.getDistributorRegions({
        ...paginate,
        ...{ id: this.distributorId },
      });
    },
    isSelected(row) {
      if (this.selected.includes(row)) {
        return true;
      }
      return false;
    },
    prepareAttached() {
      return this.allAttachedRegionData.concat(
        this.selected.map(row =>
          // eslint-disable-next-line
          ({
            ...row,
            name: row.name,
            project_id: this.distributorId,
            status_id: row.id,
          })
        )
      );
    },
    prepareDetached() {
      return this.allAttachedRegionData.filter(
        row => !this.selected.some(selected => compareObjects(row, selected))
      );
    },
    reloadList(paginate) {
      if (paginate.search == null) {
        this.getRegionList({
          ...paginate,
          page: 1,
          skip: 0,
          take: 10,
        });
        paginate.page = 1;
      } else {
        paginate.search = null;
      }
    },
    saveError(error) {
      this.activeAlert({
        message: `${error.message} <br/> ${error.data}`,
        theme: 'danger',
      });
    },
    saveSuccess() {
      this.selected = [];
      this.reloadList(this.pagination);
      this.reloadList(this.paginationAttached);

      this.activeAlert({
        message: 'Sincronização salva com sucesso',
        theme: 'success',
      });
    },
    selectRow(row, type) {
      if (type !== this.type) {
        this.type = type;
        this.selected = [];
      }
      if (row.disabled) {
        return false;
      }
      const index = this.selected.indexOf(row);
      if (index > -1) {
        return this.selected.splice(index, 1);
      }
      return this.selected.push(row);
    },
    sync() {
      if (this.type === ATTACHED) {
        return this.attach();
      }
      return this.detach();
    },
    onChangeStates(value) {
      this.pagination.state = value;
      this.pagination.skip = 0;
      this.pagination.page = 1;
    },
  },
  mounted() {
    this.distributorId = parseInt(this.$route.params.id, Number);
    Events.$on('update:pagination_detached_regions', pagination => {
      this.getRegionList(pagination);
    });
    Events.$on('update:pagination_attached_regions', pagination => {
      this.getRegionList(pagination);
    });
    this.getRegions();
  },
  destroyed() {
    Events.$off('update:pagination_detached_regions');
    Events.$off('update:pagination_attached_regions');
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.row-table {
  border-radius: 0.3rem;
}

.table {
  border-radius: 0.3rem;
  .no-content {
    vertical-align: middle;
  }
  .selected {
    background: lighten($cyan, 45%);
  }
  &-sync {
    tr td {
      height: 47px;
    }
  }
}
.btn-outline-info {
  font-size: 1.4rem;
  padding: 0px 20px;
}
</style>
